export const BUSINESS = {
  name: "Deaf Education Consulting LLC",
  owner: "Michelle Andros",
  email: "deafeducationconsultingllc@gmail.com",
  phone: "724-454-6332",
  licensing: "Licensed in Pennsylvania",
  reach: "Serving clients worldwide, in person or virtually",
  travel: "June, July and August",
  bookingUrl: "https://calendar.app.google/PPuK6LxoTF5REbFF6",
  bookingEmbed: "https://calendar.google.com/calendar/appointments/schedules/AcZssZ2n52Zr5ubFEGTKDsRxkwl2HkFZiZN-0hLDhK6v8jYR4WG1wUQ602e8b0_WBbqPFB6-ta-dttrl?gv=true",
};

export const SOCIAL = [
  { label: "Facebook", handle: "Deaf Education Consulting LLC", url: "https://www.facebook.com/share/1M46MUMasC/" },
  { label: "Instagram", handle: "@deaf_ed_consult", url: "https://www.instagram.com/deaf_ed_consult" },
  { label: "LinkedIn", handle: "Michelle Andros", url: "https://www.linkedin.com/in/michelle-andros-98ba60267" },
];

export const IMAGES = {
  hero: {
    src: "https://images.pexels.com/photos/8613120/pexels-photo-8613120.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "A teacher and a young student working together at a classroom table",
  },
  portrait: {
    src: "/images/michelle-andros-portrait.webp",
    alt: "Portrait of Michelle Andros, owner of Deaf Education Consulting LLC, smiling in a navy blazer",
  },
  services: {
    src: "https://images.unsplash.com/photo-1558907353-ceb54f3882ed?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    alt: "Colorful wooden alphabet blocks stacked on a table",
  },
};

export const ROLES = ["School or district", "Family", "Educator", "Other professional"];

export const PATHWAYS = [
  {
    key: "schools", role: "School or district", title: "Schools & districts",
    text: "Program reviews, D/HH program support, assessments and staff training that fit the way your schools already work.",
    img: "https://images.unsplash.com/photo-1680178776508-41a276595b0f?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    alt: "School staff meeting around a table in a library",
  },
  {
    key: "families", role: "Family", title: "Families",
    text: "Plain-language guidance before, during and after IEP meetings, from someone who has sat on the school side of the table.",
    img: "https://images.unsplash.com/photo-1583468982228-19f19164aee2?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    alt: "A parent and child reading a book together",
  },
  {
    key: "educators", role: "Educator", title: "Educators",
    text: "Practical professional development, Visual Phonics training and coaching for teachers of D/HH students and general educators.",
    img: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    alt: "Teachers seated in a classroom during a training session",
  },
  {
    key: "professionals", role: "Other professional", title: "Other professionals",
    text: "Collaboration with SLPs, audiologists, administrators and university programs, including guest lectures and speaking.",
    img: "https://images.unsplash.com/photo-1667581357884-383011327fd9?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    alt: "Two professionals collaborating over notes at a desk",
  },
];

export const SERVICES = [
  {
    slug: "school-consultation", icon: "square", title: "School consultation and D/HH program support",
    short: "Support for schools and districts building or strengthening services for Deaf and Hard of Hearing students.",
    body: "Consultation on program design, service delivery, staffing and compliance for D/HH students, drawing on experience as an itinerant teacher of the Deaf, educational consultant and program director.",
    for: "Schools & districts",
    delivery: ["In person", "Virtual"],
  },
  {
    slug: "assessments-iep", icon: "page", title: "Educational assessments and IEP consultation",
    short: "Comprehensive assessment and practical, compliant IEP guidance, from eligibility to service delivery.",
    body: "Help with assessment planning, functional performance, the Expanded Core Curriculum, and writing best-practice, compliant IEPs. Available to school teams and to families preparing for meetings.",
    for: "Schools, families",
    delivery: ["In person", "Virtual"],
  },
  {
    slug: "professional-development", icon: "triangle", title: "Professional development and staff training",
    short: "Workshops, courses and guest speaking on a variety of topics related to deaf education.",
    body: "Trainings for teachers of the Deaf, general educators, SLPs and administrators, including collaboration, literacy strategies, assessment and secondary transition. Guest lectures and conference presentations are also available.",
    for: "Educators, schools, conferences",
    delivery: ["In person", "Virtual"],
  },
  {
    slug: "visual-phonics", icon: "hand", title: "Visual Phonics training",
    short: "See the Sound Visual Phonics training, offered live and virtually.",
    body: "Training delivered by a See the Sound Visual Phonics Trainer (International Communication Learning Institute) for teachers, specialists and teams who want a multisensory approach to phonics.",
    for: "Educators, SLPs, schools",
    link: { label: "Learn about See the Sound Visual Phonics", url: "https://seethesound.org/visual_phonics.html" },
    delivery: ["In person", "Virtual"],
  },
  {
    slug: "family-guidance", icon: "circle", title: "Family guidance and advocacy support",
    short: "Clear guidance for families of Deaf and Hard of Hearing students navigating school services.",
    body: "Understanding evaluations, preparing for IEP meetings, knowing which questions to ask, and following up afterward, with support from someone who understands both the school side and the family side.",
    for: "Families",
    delivery: ["In person", "Virtual"],
  },
  {
    slug: "direct-instruction", icon: "wave", title: "Direct instruction and hearing support services",
    short: "Instruction and hearing support for D/HH students from a certified teacher of the Deaf.",
    body: "Direct instruction and itinerant-style hearing support services, arranged to fit the student, the school and the setting.",
    for: "Schools, families",
    delivery: ["In person", "Virtual"],
  },
];

export const FAQS = [
  { q: "Do you work in person or virtually?", a: "Both. Services are delivered in person or virtually depending on where you are. Virtual sessions are available anywhere." },
  { q: "Where do you work?", a: "Deaf Education Consulting LLC is licensed in Pennsylvania and works with clients all over the world. The best months for travel to in-person work are June, July and August." },
  { q: "Do you help families with IEPs?", a: "Yes. Families can get help preparing for IEP meetings, understanding evaluations and goals, and following up afterward." },
  { q: "Can you work directly with our school team?", a: "Yes. School consultation and D/HH program support, assessments, IEP consultation and staff training are all available to schools and districts." },
  { q: "Do you offer Visual Phonics training?", a: "Yes. Michelle is a See the Sound Visual Phonics Trainer and offers training live and virtually." },
  { q: "Can you speak at our conference or event?", a: "Yes. Training and guest speaking are available on a variety of topics related to deaf education, in person or virtually." },
  { q: "Can we meet using sign language?", a: "Yes. Michelle is sign language proficient." },
  { q: "How does online booking work?", a: "Pick an open date and time on the booking page. Google sends you a confirmation email with the details right away." },
  { q: "How do I get pricing?", a: "Every project is different, so pricing is shared through a quote. Use the quote request form on the Contact page and describe what you need." },
];

export const PROFILE = {
  education: [
    { title: "BA, Education of Persons with Hearing Loss", where: "Indiana University of Pennsylvania", year: "1996" },
    { title: "MA, Education Administration and Supervision", where: "Shenandoah University, Winchester, VA", year: "2001" },
    { title: "Special Education Supervisory Certification", where: "Slippery Rock University", year: "2015" },
  ],
  licensure: [
    { title: "Pennsylvania Level 2 Teaching License: Hearing Impaired", year: "2008–present" },
    { title: "Pennsylvania Level 2 Teaching License: English (7–12)", year: "2008–present" },
    { title: "Special Education Administration / Supervisory", year: "2015–present" },
    { title: "See the Sound Visual Phonics Trainer, International Communication Learning Institute", year: "2017–present" },
    { title: "CPR / First Aid", year: "2023–present" },
  ],
  experience: [
    { years: "2025–present", role: "Ambassador", where: "Eduplex Institute, South Africa" },
    { years: "2024–present", role: "Coordinator of Itinerant Services / Teacher of the Deaf", where: "Western Pennsylvania School for the Deaf, Pittsburgh, PA" },
    { years: "2023–present", role: "Owner, Consultant", where: "Deaf Education Consulting LLC, Irwin, PA" },
    { years: "2021–present", role: "Part owner, Director of Professional Outreach, Courses & Virtual Conference", where: "Supporting Success for Children with Hearing Loss" },
    { years: "2021–2022", role: "Adjunct Professor", where: "Robert Morris University, Moon, PA" },
    { years: "2018–2024", role: "Director of External Education", where: "DePaul School for Hearing and Speech, Pittsburgh, PA" },
    { years: "2015–2018", role: "Educational Consultant (D/HH, Secondary Transition, Inclusive Practices, Procedural Safeguards, Assistive Technology)", where: "Pennsylvania Training and Technical Assistance Network (PaTTAN)" },
    { years: "2007–2015", role: "Itinerant Teacher of the Deaf", where: "Allegheny Intermediate Unit #3, Homestead, PA" },
    { years: "2006–2007", role: "Deaf and HH Teacher", where: "Pressley Ridge School for the Deaf, Pittsburgh, PA" },
    { years: "2001–2003", role: "Special Education / Deaf and HH Teacher", where: "Winchester Public Schools, VA" },
    { years: "1999–2001", role: "Special Education / Deaf and HH Teacher", where: "Warren County School District, Front Royal, VA" },
    { years: "1996–1999", role: "Case Worker", where: "Department of Child and Youth Services, Blair County, PA" },
  ],
  memberships: [
    "Council for Exceptional Children",
    "National Association of the Deaf",
    "Alexander Graham Bell Association",
    "Supporting Success for Children with Hearing Loss",
    "Pennsylvania Educators of Students who are Deaf & HH",
  ],
  talks: [
    { year: "2026", text: "Guest lecturer, University of Colorado and Edinboro University Deaf Education programs: Assessment and Collaboration" },
    { year: "2026", text: "Guest panelist, Q&A Mini Conference, Supporting Success for Children with Hearing Loss" },
    { year: "2024", text: "Presenter, American Society for Deaf Children Conference, Charleston, SC: Expanded Core Competencies and Functional Performance for Deaf Education" },
    { year: "2024", text: "Guest presenter, Maryland State Deaf and Hard of Hearing Statewide Conference: Soundless Symphony" },
    { year: "2024", text: "Guest presenter, Supporting Success for Students with Hearing Loss Biennial Conference: Make and Take! Strategies for Teaching Each Strand of the Reading Rope" },
    { year: "2023", text: "Opening Doors, Unlocking Potential: Comprehensive Assessment and Collaboration, Eligibility to Service Delivery" },
    { year: "2022", text: "Creating Best Practice and Compliant IEPs (prerecorded course), Supporting Success for Children with Hearing Loss" },
    { year: "2022", text: "Collaboration between TODHH and SLPs in General Education, PaTTAN Hour with the Expert Series (with M. Parfitt)" },
    { year: "2020–2022", text: "Guest lecturer, University of Pittsburgh School of Health and Rehabilitation Sciences" },
  ],
};

export const SPEAKING_TOPICS = [
  { title: "Comprehensive assessment and collaboration", text: "Opening doors and unlocking potential, from eligibility to service delivery for D/HH students." },
  { title: "Expanded Core Competencies and functional performance", text: "What the Expanded Core Curriculum looks like in deaf education, and how to measure functional performance." },
  { title: "Creating best-practice, compliant IEPs", text: "Writing IEPs for D/HH students that meet compliance and actually guide instruction." },
  { title: "Teachers of the D/HH and SLPs working together", text: "Collaboration between TODHH and speech-language pathologists in general education settings." },
  { title: "Literacy strategies for every strand of the Reading Rope", text: "Hands-on, make-and-take strategies for teaching reading to D/HH learners." },
  { title: "See the Sound Visual Phonics", text: "Training in Visual Phonics, offered live or virtually.", link: { label: "Learn about See the Sound Visual Phonics", url: "https://seethesound.org/visual_phonics.html" } },
  { title: "A topic for your audience", text: "Training and guest speaking on a variety of topics related to deaf education, shaped around your group." },
];

export const EVENT_TYPES = ["Conference", "University or college", "School or district training", "Parent or family group", "Other"];
